import { Calendar } from 'primereact/calendar';

export const FiltroRangoFechas = ({ valueInicio, valueFin, onChange, icon = "pi pi-calendar", minProps = {}, maxProps = {}, ...props }) => {

    const handleChangeInicio = (e) => {
        const nuevaInicio = e.value || null;
        // Si la nueva fecha de inicio es posterior al fin, limpiamos el fin
        const nuevoFin = valueFin && nuevaInicio && nuevaInicio > valueFin ? null : valueFin;
        onChange({ inicio: nuevaInicio, fin: nuevoFin });
    };

    const handleChangeFin = (e) => {
        onChange({ inicio: valueInicio, fin: e.value || null });
    };

    return (
        <div className="flex gap-2 w-full">
            <div className="p-inputgroup w-6">
                <span className="p-inputgroup-addon bg-white border-right-none px-2">
                    <i className={`${icon} text-primary text-sm`}></i>
                </span>
                <Calendar readOnlyInput dateFormat="yy/mm/dd" {...props} {...minProps} value={valueInicio} onChange={handleChangeInicio}
                    placeholder="Fecha inicio" maxDate={valueFin || undefined} className="w-full" />
            </div>
            <div className="p-inputgroup w-6">
                <span className="p-inputgroup-addon bg-white border-right-none px-2">
                    <i className={`${icon} text-primary text-sm`}></i>
                </span>
                <Calendar readOnlyInput dateFormat="yy/mm/dd" {...props} {...maxProps} value={valueFin} onChange={handleChangeFin}
                    placeholder="Fecha fin" minDate={valueInicio || undefined} className="w-full" />
            </div>
        </div>
    );
};